export default __webpack_public_path__ + "59b9b5719da395d5920d8529d69bfaec.png";